import { connect } from 'react-redux';
import { CarouselMapView } from './view';
import { mapStateToProps } from './mapStateToProps';
import { mapDispatchToProps } from './mapDispatchToProps';

export default (
    connect(mapStateToProps, mapDispatchToProps)(
        CarouselMapView
    )
);
